import React, { useState, useEffect } from 'react';
import api from '../services/api';

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/D';
  const date = new Date(dateString);
  date.setDate(date.getDate() + 1);
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

function AlertsPage() {
  const [alertsData, setAlertsData] = useState(null);

  useEffect(() => {
    api.get('/alerts')
      .then(response => {
        setAlertsData(response.data);
      })
      .catch(error => {
        console.error('Houve um erro ao buscar os alertas!', error);
      });
  }, []);

  if (!alertsData) {
    return <div>Carregando Alertas...</div>;
  }

  const hasAlerts = alertsData.despesas_atrasadas?.length > 0
    || alertsData.despesas_vencendo_hoje?.length > 0
    || alertsData.despesas_proximas?.length > 0
    || alertsData.receitas_vencendo_hoje?.length > 0
    || alertsData.receitas_proximas?.length > 0
    || (alertsData.uso_cartao_credito && Object.keys(alertsData.uso_cartao_credito).length > 0)
    || (alertsData.saldo_banco_baixo && Object.keys(alertsData.saldo_banco_baixo).length > 0)
    || (alertsData.uso_cheque_especial && Object.keys(alertsData.uso_cheque_especial).length > 0);

  const renderItemList = (items) => (
    <ul className="list-unstyled mb-0">
      {items.map(item => (
        <li key={item.id} className="d-flex justify-content-between align-items-center py-1 border-bottom border-light">
          <span>{item.description}</span>
          <span className="text-nowrap ms-3">
            <strong>{formatCurrency(item.amount)}</strong>
            <small className="ms-2 opacity-75">{formatDate(item.due_date)}</small>
          </span>
        </li>
      ))}
    </ul>
  );

  const renderObjectAlerts = (data) => (
    <ul className="list-unstyled mb-0">
      {Object.keys(data).map(key =>
        data[key].map((alert, index) => (
          <li key={`${key}-${index}`} className="py-1 border-bottom border-light">{alert}</li>
        ))
      )}
    </ul>
  );

  return (
    <div>
      <h1>Alertas</h1>

      {alertsData.despesas_vencendo_hoje?.length > 0 && (
        <div className="card text-white bg-danger mb-3">
          <div className="card-header">Despesas Vencendo Hoje</div>
          <div className="card-body">{renderItemList(alertsData.despesas_vencendo_hoje)}</div>
        </div>
      )}

      {alertsData.receitas_vencendo_hoje?.length > 0 && (
        <div className="card text-white bg-success mb-3">
          <div className="card-header">Receitas Vencendo Hoje</div>
          <div className="card-body">{renderItemList(alertsData.receitas_vencendo_hoje)}</div>
        </div>
      )}

      {alertsData.despesas_proximas?.length > 0 && (
        <div className="card text-white bg-warning mb-3">
          <div className="card-header">Despesas nos Próximos 3 Dias</div>
          <div className="card-body">{renderItemList(alertsData.despesas_proximas)}</div>
        </div>
      )}

      {alertsData.receitas_proximas?.length > 0 && (
        <div className="card text-dark bg-light mb-3" style={{ border: '1px solid #28a745' }}>
          <div className="card-header text-white bg-success bg-opacity-75">Receitas nos Próximos 3 Dias</div>
          <div className="card-body">{renderItemList(alertsData.receitas_proximas)}</div>
        </div>
      )}

      {alertsData.despesas_atrasadas?.length > 0 && (
        <div className="card text-white bg-danger mb-3">
          <div className="card-header">Despesas Atrasadas</div>
          <div className="card-body">{renderItemList(alertsData.despesas_atrasadas)}</div>
        </div>
      )}

      {alertsData.uso_cartao_credito && Object.keys(alertsData.uso_cartao_credito).length > 0 && (
        <div className="card text-white bg-info mb-3">
          <div className="card-header">Uso de Cartão de Crédito</div>
          <div className="card-body">{renderObjectAlerts(alertsData.uso_cartao_credito)}</div>
        </div>
      )}

      {alertsData.saldo_banco_baixo && Object.keys(alertsData.saldo_banco_baixo).length > 0 && (
        <div className="card text-white bg-secondary mb-3">
          <div className="card-header">Saldo Baixo em Banco</div>
          <div className="card-body">{renderObjectAlerts(alertsData.saldo_banco_baixo)}</div>
        </div>
      )}

      {alertsData.uso_cheque_especial && Object.keys(alertsData.uso_cheque_especial).length > 0 && (
        <div className="card text-white bg-dark mb-3">
          <div className="card-header">Uso de Cheque Especial</div>
          <div className="card-body">{renderObjectAlerts(alertsData.uso_cheque_especial)}</div>
        </div>
      )}

      {!hasAlerts && (
        <div className="alert alert-success" role="alert">
          Nenhum alerta no momento!
        </div>
      )}
    </div>
  );
}

export default AlertsPage;
